import React, { Component } from "react";
import ReactDom from "react-dom";
import "../styles/main.less";
// import moment from "moment";
import ModalGeneral from "../common/scripts/ModalGeneralComponent";
import { isCallService } from "../common/scripts/services";
import { Auth } from "../components/Auth";
import { Surveys } from "../components/Surveys";
import { IndexFlujoEncuesta } from '../components/flujo/IndexFlujoEncuesta';
import { getSurveys } from "../common/scripts/getSurveys";

const TITULO = "Encuesta salud";
const BUTTON_CANCELAR1 = "Salir";
const BUTTON_ACEPTAR1 = "Responder";
const STAGE = {
  INITIAL_1: 'INITIAL_1',
  CARDS_2: 'CARDS_2',
  SELECTED_SURVEY_3: 'SELECTED_SURVEY_3',
}

export default class Index extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loadingPreguntas: true,
      stage: STAGE.INITIAL_1,
      tiposDocumentos: [],
      showModal: false,
      btnModalUno: resourcesEncuesta.getResource("es", "nsEncuesta", "Form.PopUp.NameButton.Aceptar"),
      btnModalDos: resourcesEncuesta.getResource("es", "nsEncuesta", "Form.PopUp.NameButton.Cerrar"),
      typeModal: resourcesEncuesta.getResource("es", "nsEncuesta", "Form.PopUp.NameButton.Cerrar"),
    };
    this.pnpService = new ServicioPnp();
    // this.activeModal = this.activeModal.bind(this);
    this.getErrorMessage = this.getErrorMessage.bind(this);
  }

  componentDidMount() {
    this.fetchDocuments()
  }  
  
  fetchDocuments() {
    // compensar.mostrarLoading('#Landing-Encuestas')
    fetch(`${document.location.origin}/_vti_bin/ServiciosProveedores/ServicioProveedores.svc/TiposDocumentoIdentificacion`)
      .then(res => res.json())
      .then( ({ Result }) => {
        const formatDocuments = Result.map((item) => ({
          value: item.Documento,
          label: item.Documento,
          userTypeId: item.IdDocumento,
          isDisabled: false,
          abrevation: item.Sigla,
        }));
        this.setState({
          tiposDocumentos: formatDocuments,
        })
        // compensar.quitarLoading('#Landing-Encuestas')
      })
  }

  async handleSubmit() {
    let arrayToSave = []
    this.state.preguntasRespuestas.forEach((respuesta) => {
      arrayToSave.push({
        Codigo: respuesta.Codigo,
        TipoPregunta: respuesta.TipoPregunta,
        Respuesta: respuesta.Respuesta,
      })
    })
    await this.addItem(JSON.stringify(arrayToSave))
    this.setState({ showModal: false })
    if(window.TempCallbackEncuesta) window.TempCallbackEncuesta()
  }

  handleAction() {
    
  }

  handleHide() {
    this.setState({ showModal: false })
  }

  handleSubmitFinish({userInfo, surveys}) {
    this.setState({
      stage: STAGE.CARDS_2,
      userInfo,
      surveys,
    })
  }

  getErrorMessage(error, btnCerrarCancelar, btnAceptar, btnCerrar) {
    this.setState({
      titleModal: sharedResources.getResource(
        "es",
        "nsGeneralResources",
        "Modal.Title.Error"
      ),
      btnCerrarCancelar: btnCerrarCancelar,
      messageModal: error,
      iconoModal: sharedResources.getResource("es", "nsGeneralResources", "Iconos.Error"),
      colorIco: sharedResources.getResource("es", "nsGeneralResources", "Colores.Azul"),
      noX: sharedResources.getResource("es", "nsGeneralResources", "Modal.Bolean.False"),
      noAceptar: btnAceptar,
      noCancelar: btnCerrar,
      showModal: true,
    });
  }

  handleSelectEncuesta(dataToStorage) {
    this.setState({
      dataToStorage,
      stage: STAGE.SELECTED_SURVEY_3,
    })
  }

  
  // activeModal(
  //   title,
  //   btnCerrarCancelar,
  //   message,
  //   icono,
  //   colorIco,
  //   noX,
  //   noAceptar,
  //   noCancelar
  // ) {
  //   this.setState({
  //     titleModal: title,
  //     btnCerrarCancelar: btnCerrarCancelar,
  //     messageModal: message,
  //     iconoModal: icono,
  //     colorIco: colorIco,
  //     noX: noX,
  //     noAceptar: noAceptar,
  //     noCancelar: noCancelar,
  //     showModal: true,
  //   });
  // }

  handleVolverALogin() {
    this.setState({
      stage: STAGE.INITIAL_1,
    });
    compensar.quitarLoading("#Landing-Encuestas");
  }

  handleVolverA2() {
    const userTypeId = sessionStorage.getItem('userTypeId');
    const userId = sessionStorage.getItem('userId');
    getSurveys.call(this, userTypeId, userId, (data) => {
      this.setState({
        stage: STAGE.CARDS_2,
      });
      compensar.quitarLoading("#Landing-Encuestas");
    });
  }
  
  render() {
    return (
      <>
        {this.state.showModal &&
          <ModalGeneral
            showModal={this.state.showModal}
            closeModal={() =>
              console.log('Cerrarrr')
            }
            handleHide={this.handleHide.bind(this)}
            MessageTitle={TITULO}
            msg={this.state.messageModal}
            MainButtonAction={this.handleHide.bind(this)}
            AltButtonAction={this.handleAction.bind(this)}
            disabled={''}
            Icono={this.state.iconoModal}
            colorIco={this.state.colorIco}
            MainButtonText={this.state.btnModalUno}
            CloseAction={this.handleHide.bind(this)}
            // AltButtonText={this.state.btnModalDos}
          />
        }
        {
          this.state.stage === STAGE.INITIAL_1 && this.state.tiposDocumentos &&
          <Auth 
            tiposDocumentos={this.state.tiposDocumentos} 
            handleSubmitFinish={this.handleSubmitFinish.bind(this)}
            getErrorMessage={this.getErrorMessage}
          />
        }
        {
          this.state.stage === STAGE.CARDS_2 &&
          <Surveys
            userInfo={this.state.userInfo}
            surveys={this.state.surveys}
            getErrorMessage={this.getErrorMessage}
            handleSelectEncuesta={this.handleSelectEncuesta.bind(this)}
            handleVolverALogin={this.handleVolverALogin.bind(this)}
          />
        }
        {
          this.state.stage === STAGE.SELECTED_SURVEY_3 &&
          <IndexFlujoEncuesta
            dataToStorage={this.state.dataToStorage}
            getErrorMessage={this.getErrorMessage}
            handleVolverA2={this.handleVolverA2.bind(this)}
          />
        }
      </>
    );
  }
}

function App(params) {
  return (
    <div id="Landing-Encuestas">
      <div className="loadingWraper">
        <div className="compensarLoading">
          <span>cargando... </span>
        </div>
      </div>
      <Index />
    </div>
  )
}

ReactDom.render(<App />, document.getElementById("encuestaSalud_SL"));
